import React from 'react';

import { Divider } from "primereact/divider";
import "../AshaProfileView/AshaProfileViewStyle.scss";


const AnmProfileView = ({ profile }) => {
  const { anmId, joiningDate, phc, subCenter, mobileNumber, age, address, aadhar, bankAccountNo } = profile.anmdetails || {};
  return (
    <div>
      <div className="grid mt-2">
        <div className="flex sm:col-12 md:col-4 p-5 w-max p-3">
          <div className="flex flex-column justify-content-start" style={{color:"#1D2965", marginRight:"20rem"}}>
            <div className="font-semibold text-sm mb-2">ANM Details</div>
            <div className="font-light text-sm mt-1 mb-1 text-sm" testId="anm-id">
              ANM ID : {anmId}
            </div>
            <div className="font-light text-sm mt-1 mb-2 text-sm">
              Joining Date : {joiningDate}
            </div>
            <div className="font-light text-sm mt-1 mb-1 text-sm">
              PHC : {phc}
            </div>
            <div className="font-light text-sm mt-1 mb-2 text-sm">
              Subcenter : {subCenter}
            </div>
          </div>
          <Divider layout="vertical"/>
          <div className="flex flex-column justify-content-center text-sm" style={{color:"#1D2965"}} >
            <div className="font-semibold text-sm mb-2">Personal Details</div>
            <div className="font-light text-sm mt-1 mb-1 text-sm">
              Mobile No. {mobileNumber}
            </div>
            <div className="font-light text-sm mt-1 mb-1">
              Age : {age}
            </div>
            <div className="font-light text-sm mt-1 mb-1">
              Address : {address}
            </div>
            <div className="flex font-light text-sm mt-1 mb-1">
              Aadhar : <div className="verifiedStyle" style={{}}>{aadhar}</div>
            </div>
            <div className="font-light text-sm mt-1 mb-2">
              Bank Account No. :{bankAccountNo}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnmProfileView;
